import React, { useEffect } from "react";
import "./index.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import SearchIcon from "@mui/icons-material/Search";
import { logUserOut } from "../../Constants/api";
import { useDispatch, useSelector } from "react-redux";
import Logo from "./logo/logo";

const Navbar = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="navbar"
      style={{
        alignItems: "center",
        display: "flex",
      }}
    >
      <div
        className="navbar-logo"
        style={{
          alignItems: "center",
          display: "flex",
        }}
      >
        <NavLink
          to="/"
          className="logo"
          style={{
            alignItems: "center",
            display: "flex",
          }}
        >
          <Logo />
        </NavLink>
      </div>
      <div className="navbar-links">
        <NavLink
          to="/"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          Home
        </NavLink>
        <NavLink
          to="/productions"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          English Productions
        </NavLink>
        {/* <NavLink
          to="/bio"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          Bio
        </NavLink> */}{" "}
        {/* <NavLink
          to="/news"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          News
        </NavLink> */}
        {/* <NavLink
          to="/gallery"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          Gallery
        </NavLink> */}
        <NavLink
          to="/testimonials"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          Testimonials
        </NavLink>
        <NavLink
          to="/contact"
          className={`nav-item ${
            location.pathname === "/" ? "white-color" : ""
          }`}
        >
          Contact
        </NavLink>
        <div className="navbar-actions">
          {/* <SearchInput /> */}
          <a
            href={userData.id ? "logout" : "Login"}
            style={{
              color: "white",
            }}
            onClick={(e) => {
              e.preventDefault();

              if (userData.id) {
                logUserOut(dispatch);
              } else {
                navigate("/signin");
              }
            }}
            className="profile-icon"
          >
            {userData.id ? (
              <LogoutIcon color="#ffd4db" htmlColor="#ffd4db" />
            ) : (
              <LoginIcon color="#ffd4db" htmlColor="#ffd4db" />
            )}
          </a>
        </div>
      </div>

      <div className="navbar-mobile-menu">
        <HamburgerMenuMobile />
      </div>
    </nav>
  );
};

function HamburgerMenuMobile() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [click, setClick] = React.useState(false);
  const handleClick = (e, route) => {
    e && e.preventDefault();
    setClick((p) => {
      return !p;
    });
    route && navigate(route);
  };

  useEffect(() => {
    if (click === true) {
      document.documentElement.style.overflowY = "hidden";
    } else {
      document.documentElement.style.overflowY = "auto";
    }
  }, [click]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 950) {
        setClick(false);
      }
    });
  });

  return (
    <div>
      <label
        className="menu-label"
        htmlFor="navi-toggle"
        onClick={(e) => handleClick(e)}
      >
        <span className={`icon ${click ? "clicked" : ""}`}>&nbsp;</span>
      </label>
      <div className={`nav-background ${click ? "clicked" : ""}`}>&nbsp;</div>

      <nav className={`navigation ${click ? "clicked" : ""}`}>
        <ul className="list">
          <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/")}
              href="/"
            >
              Home
            </a>
          </li>
          <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/productions")}
              href="/productions"
            >
              English Productions
            </a>
          </li>
          {/* <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/bio")}
              href="/bio"
            >
              Bio
            </a>
          </li> */}
          {/* <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/bio")}
              href="/news"
            >
              News
            </a>
          </li> */}
          {/* <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/gallery")}
              href="/gallery"
            >
              Gallery
            </a>
          </li> */}
          <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/testimonials")}
              href="/testimonials"
            >
              Testimonials
            </a>
          </li>
          <li>
            <a
              className="item-link"
              onClick={(e) => handleClick(e, "/contact")}
              href="/contact"
            >
              Contact Us
            </a>
          </li>
          {/* <li>
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <SearchInput />
            </div>
          </li> */}
          <li>
            <a
              className="item-link"
              onClick={() => {
                if (userData.id) {
                  logUserOut(dispatch);
                } else {
                  navigate("/signin");
                }
                handleClick();
              }}
            >
              {userData.id ? "Log Out" : "Log In"}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Navbar;

const SearchInput = () => {
  return (
    <div className="search-container">
      <div className="icon-container">
        <SearchIcon />
      </div>
      <input type="text" className="styled-input" placeholder="Search..." />
    </div>
  );
};
